"use strict";

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _classCallCheck = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");
var _createClass = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");
Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * [[TimeoutScheduler]] calls the callback once after timeoutMs milliseconds.
 */
var TimeoutScheduler = /*#__PURE__*/function () {
  function TimeoutScheduler(timeoutMs) {
    _classCallCheck(this, TimeoutScheduler);
    this.timeoutMs = timeoutMs;
    // eslint-disable-next-line
    this.timer = null;
  }
  _createClass(TimeoutScheduler, [{
    key: "start",
    value: function start(callback) {
      var _this = this;
      this.stop();
      this.timer = setTimeout(function () {
        clearTimeout(_this.timer);
        callback();
      }, this.timeoutMs);
    }
  }, {
    key: "stop",
    value: function stop() {
      if (this.timer !== null) {
        clearTimeout(this.timer);
        this.timer = null;
      }
    }
  }]);
  return TimeoutScheduler;
}();
exports.default = TimeoutScheduler;